class Accordion extends HTMLDivElement {
  constructor() {
    super();
    this.el = this.querySelector('details');
    this.summary = this.el.querySelector('summary');
    this.content = this.el.querySelector('.footer-block__details-content');
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.duration = 400;

    const accordion = new AccordionGlobals();
    this.summary.addEventListener('click', (e) => accordion.onClick(e, this));
  }
}

function addCustomElement() {
  customElements.define('footer-accordion', Accordion, { extends: 'div'});
}

addEventListener('DOMContentLoaded', () => addCustomElement());

// Gorgias - start
const initGorgiasChatPromise = window.GorgiasChat
  ? window.GorgiasChat.init()
  : new Promise(function (resolve) {
      window.addEventListener('gorgias-widget-loaded', function () {
        resolve()
      })
    })

initGorgiasChatPromise.then(async () => {
  const gorgiasChatContainer = document.querySelector('#gorgias-chat-container')
  gorgiasChatContainer.classList.add('hidden')
  GorgiasChat.hidePoweredBy(true)

  GorgiasChat.on('widget:opened', function (data) {
    gorgiasChatContainer.classList.remove('hidden')
    document.addEventListener('mouseup', handleClickOffChatModal)
  })

  GorgiasChat.on('widget:closed', function (data) {
    // Allow for window close animation before hiding button
    setTimeout(() => {
      gorgiasChatContainer.classList.add('hidden')
    }, 500)
    document.removeEventListener('mouseup', handleClickOffChatModal)
  })

  // Clicking close button has animation but the close method doesn't, 
  // so we're trying to trigger a click on the button and 
  // then just calling close method as a fallback if we can't find the button
  function handleClickOffChatModal(e) {
    if (!gorgiasChatContainer.contains(e.target)) {
      const closeButton = document
        .querySelector('#chat-button')
        ?.contentWindow?.document.body.querySelector('#gorgias-chat-messenger-button')
      if (closeButton) {
        closeButton.click()
      } else {
        // Fallback
        GorgiasChat?.close()
      }
    }
  }

  document.querySelectorAll('.js-chat-trigger').forEach((trigger) => {
    if (GorgiasChat?.isBusinessHours()) {
      trigger.classList.add('active')
    } else {
      trigger.classList.remove('active')
    }

    trigger.addEventListener('click', (event) => {
      event.preventDefault()
      try {
        window.GorgiasChat?.open()
      } catch (e) {
        console.error(e)
      }
    })
  })
})

if (window.gorgias?.use_custom_loader) {
  // Wait for the customer to get close to the footer and then run the gorgias scripts
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const gorgiasScripts = document.querySelectorAll('script[data-gorgias-script]')

        gorgiasScripts.forEach(script => {
          const dataSrc = script.getAttribute('data-src')
          if (dataSrc) {
            script.src = dataSrc
          }
        })

        observer.unobserve(entry.target)
      }
    })
  }, {
    root: null,
    threshold: 0,
    rootMargin: '-50% 0px 0px 0px'
  })

  const footer = document.querySelector('footer.footer')
  if (footer) {
    observer.observe(footer)
  }
}
// Gorgias - end
